<template>
  <div class="simple-date-picker">
    <div class="rows">
      <div class="cols-sm-4">
        <select v-model="inputVal.year" class="form-control" :readonly="readonly" :disabled="disabled">
          <option v-for="(option, optionIndex) in yearOptions" :key="_uid + '-year-' + optionIndex" :value="option.value">
            {{ option.text }}
          </option>
        </select>
        <div class="clear" />
      </div>
      <div class="cols-sm-4">
        <select v-model="inputVal.month" class="form-control" :readonly="readonly" :disabled="disabled">
          <option v-for="(option, optionIndex) in monthOptions" :key="_uid + '-month-' + optionIndex" :value="option.value">
            {{ option.text }}
          </option>
        </select>
        <div class="clear" />
      </div>
      <div class="cols-sm-4">
        <select v-model="inputVal.day" class="form-control" :readonly="readonly" :disabled="disabled">
          <option v-for="(option, optionIndex) in dayOptions" :key="_uid + '-day-' + optionIndex" :value="option.value">
            {{ option.text }}
          </option>
        </select>
        <div class="clear" />
      </div>
      <div class="clear" />
    </div>
    <div class="clear" />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      inputVal: {
        year: '',
        month: '',
        day: ''
      },
      yearOptions: [],
      monthOptions: [],
      dayOptions: [
        {
          text: this.$t('common.text.date_day'),
          value: ''
        }
      ]
    }
  },
  watch: {
    value: {
      handler: function(newVal) {
        if (newVal) {
          const dates = newVal.split('-')
          this.inputVal.year = dates[0]
          this.inputVal.month = dates[1]
          this.inputVal.day = dates[2]
          this.makeOptions(this.inputVal.year, this.inputVal.month)
        }
      },
      immediate: true
    },
    inputVal: {
      handler: function(newVal) {
        let val
        if (this.inputVal) {
          const year = newVal.year
          const month = newVal.month
          const day = newVal.day

          this.makeOptions(year, month)

          if (!year || !month || !day) {
            this.$emit('input', '')
            this.$emit('change', '')
            return
          }
          val = year + '-' + month + '-' + day
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      deep: true
    }
  },
  created() {
    this.yearOptions.push({
      text: this.$t('common.text.date_year'),
      value: ''
    })
    const currentDate = new Date()
    for (
      let i = currentDate.getFullYear();
      i >= currentDate.getFullYear() - 100;
      i--
    ) {
      this.yearOptions.push({
        text: i,
        value: i
      })
    }
    this.monthOptions.push({
      text: this.$t('common.text.date_month'),
      value: ''
    })
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({
        text: i,
        value: i
      })
    }
  },
  methods: {
    hasError(name) {
      return this.errors.has(name)
    },
    makeOptions(year, month) {
      this.dayOptions = []
      this.dayOptions.push({
        text: this.$t('common.text.date_day'),
        value: ''
      })
      for (let i = 1; i <= 28; i++) {
        this.dayOptions.push({
          text: i,
          value: i
        })
      }
      if (month) {
        if (parseInt(month) === 2) {
          if (
            (parseInt(year) % 4 === 0 && parseInt(year) % 100 !== 0) ||
            parseInt(year) % 400 === 0
          ) {
            this.dayOptions.push({
              text: 29,
              value: 29
            })
          }
        } else {
          for (let i = 29; i <= 30; i++) {
            this.dayOptions.push({
              text: i,
              value: i
            })
          }
          if (
            parseInt(month) === 1 ||
            parseInt(month) === 3 ||
            parseInt(month) === 5 ||
            parseInt(month) === 7 ||
            parseInt(month) === 8 ||
            parseInt(month) === 10 ||
            parseInt(month) === 12
          ) {
            this.dayOptions.push({
              text: 31,
              value: 31
            })
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.simple-date-picker {
  min-height: 49px;
}
</style>
